module.exports = __webpack_public_path__ + "static/media/serious-woman.10f0a4c3.svg";